import { PropsWithChildren, useCallback } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { FilterQueryContextProvider } from 'src/contexts/FilterQueryContext';
import { ReportMetricsContextProviderV2 } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';
import { ReportConfigV2 } from 'src/hooks/reportConfigs';
import { EmptyReportV2SaleCostAdjustmentsQuery } from 'src/utils/eventQueryUtils';
import {
  ReportV2Client,
  UIReportV2SaleTotalCostAdjustmentsQuery,
} from 'src/WebApiController';

export function ReportsSaleCostAdjustmentsContextProviderV2({
  reportConfig,
  isExport,
  children,
}: PropsWithChildren<{
  reportConfig: ReportConfigV2;
  isExport?: boolean;
}>) {
  const { activeAccountWebClientConfig } = useAppContext();

  const getReportMetrics = useCallback(
    (
      tempReportConfig: ReportConfigV2,
      filters: UIReportV2SaleTotalCostAdjustmentsQuery,
      pageNumber: number
    ) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getSaleTotalCostAdjustmentReportMetrics({
        ...tempReportConfig.request,
        pageNumber,
        filters,
      });
    },
    [activeAccountWebClientConfig]
  );

  const getReportMetricsSummary = useCallback(
    (
      tempReportConfig: ReportConfigV2,
      filters: UIReportV2SaleTotalCostAdjustmentsQuery
    ) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getSaleTotalCostAdjustmentReportSummary({
        ...tempReportConfig.request,
        filters,
      });
    },
    [activeAccountWebClientConfig]
  );

  return (
    <FilterQueryContextProvider<UIReportV2SaleTotalCostAdjustmentsQuery>
      initialQuery={
        (reportConfig.request.filters ||
          EmptyReportV2SaleCostAdjustmentsQuery) as UIReportV2SaleTotalCostAdjustmentsQuery
      }
      emptyQuery={EmptyReportV2SaleCostAdjustmentsQuery}
      loadQueryFromUrl={false}
    >
      <ReportMetricsContextProviderV2<UIReportV2SaleTotalCostAdjustmentsQuery>
        queryKey="getReportSaleCostAdjustmentsMetricsV2"
        getReportMetrics={getReportMetrics}
        getReportMetricsSummary={getReportMetricsSummary}
        disabled={isExport}
        reportConfig={reportConfig}
      >
        {children}
      </ReportMetricsContextProviderV2>
    </FilterQueryContextProvider>
  );
}
